import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Container,
  Breadcrumbs,
  Link,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from '@mui/material';
import { 
  Language as LanguageIcon,
  CheckCircle as CheckIcon,
  Email as EmailIcon,
} from '@mui/icons-material';

export const LanguageProficiencyTest = () => {
  const handleContactUs = () => {
    window.open('mailto:sales@driververified.com', '_blank');
  };

  const testUses = [
    'Evaluating driver candidates in the hiring process',
    'Confirming English proficiency in the onboarding process',
    'Determining whether additional English language instruction is required',
    'Determining whether or not to assign a driver for cross-border routes into the United States'
  ];

  const serviceIncludes = [
    'Assistance to setup the testing environment, including labour.',
    'Providing drivers with a practise test, followed by the official test',
    'Confirmation of license ID matching the driver',
    'Confirmation of a valid driver\'s license',
    'Confirmation of a driver\'s English proficiency upon completion, based upon benchmarking considerations',
    'Documentation including certificate',
    'Admin management and assistance',
    'DriverVerified basic subscription for Company and Drivers',
    'All drivers receive an offer for Sirius XM at $5/month'
  ];

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      {/* Breadcrumbs */}
      <Breadcrumbs sx={{ mb: 3 }}>
        <Link 
          color="inherit" 
          href="/services" 
          sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
        >
          Services
        </Link>
        <Typography color="text.primary">English Language Proficiency Test</Typography>
      </Breadcrumbs>

      {/* Header */}
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 600 }}>
          English Language Proficiency Test
        </Typography>
      </Box>

      {/* Main Content */}
      <Card sx={{ mb: 4, boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)' }}>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.7 }}>
            In Canada and the United States, drivers' English language proficiency has become a focus of transportation 
            officials. In the United States, if commercial drivers are found to be unable to speak or read in English, 
            drivers are being placed out-of-service. In some states, drivers are even being held in jail if an officer 
            determines their English skills insufficient. Additionally, when a driver has been placed out-of-service, the 
            company must send a qualified driver in their place to retrieve the truck and complete the delivery.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
            The English Language Proficiency Test is useful for:
          </Typography>
          
          <List sx={{ mb: 4 }}>
            {testUses.map((use, index) => (
              <ListItem key={index} sx={{ alignItems: 'flex-start', px: 0 }}>
                <ListItemIcon sx={{ mt: 0.5 }}>
                  <CheckIcon color="primary" />
                </ListItemIcon>
                <ListItemText primary={use} />
              </ListItem>
            ))}
          </List>

          <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.7 }}>
            Our English Language Proficiency Test service is the only online test available in Canada that's recognized 
            as a valid measure of proficiency for entry to university and college programs. However, the test itself is only 
            an indicator of English ability, discretion for placing a driver out-of-service will always be up to the individual 
            officer.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
            Our English Language Proficiency Test service includes:
          </Typography>
          
          <List sx={{ mb: 4 }}>
            {serviceIncludes.map((item, index) => (
              <ListItem key={index} sx={{ alignItems: 'flex-start', px: 0 }}>
                <ListItemIcon sx={{ mt: 0.5 }}>
                  <CheckIcon color="primary" />
                </ListItemIcon>
                <ListItemText primary={item} />
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Card>

      {/* Contact Section */}
      <Card sx={{ boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)' }}>
        <CardContent sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
            Contact us today for pricing and more information!
          </Typography>
          <Button
            variant="contained"
            size="large"
            onClick={handleContactUs}
            startIcon={<EmailIcon />}
            sx={{
              mt: 2,
              backgroundColor: '#4ecdc4',
              '&:hover': { backgroundColor: '#45b7d1' },
              px: 4,
              py: 1.5,
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            sales@driververified.com
          </Button>
        </CardContent>
      </Card>
    </Container>
  );
}; 